<h2 mat-dialog-title>Add label</h2>

<mat-dialog-content>
  <form id="label-form" (submit)="save($event)">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select [formField]="form.labelType">
          <mat-option value="harvester">Harvester</mat-option>
          <mat-option value="project">Project</mat-option>
        </mat-select>
      </mat-form-field>
    </p>

    <p>
      <app-form-control-autocomplete
        label="Labels"
        (searchString)="labelSearch.set($event)"
        [resource]="labelResource"
        [displayWith]="labelDisplayWith"
        [multiple]="true"
        [formField]="form.labels"
      />
    </p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-flat-button
    type="submit"
    form="label-form"
    [disabled]="!form.labels().value().length"
  >
    Save
  </button>
  <button mat-button type="button" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
